(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["installation-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Tab Functionality
  const tabButtons = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-tab');
      
      // Update active states
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      button.classList.add('active');
      document.getElementById(`${tabId}-content`).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filter = document.querySelector('.filter');
  if (!filter) return;
  
  const articles = document.querySelectorAll('.blog__article');
  
  filter.addEventListener('change', function() {
    const selectedCategory = this.value.trim().toLowerCase();
    
    articles.forEach(article => {
      const articleCategory = (article.dataset.category || '').trim().toLowerCase();
      if (!selectedCategory || articleCategory === selectedCategory) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials-library"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filters = document.querySelectorAll('.filter');
  const swatches = document.querySelectorAll('.swatch-item');
  const activeFilters = new Map();

  filters.forEach(filter => {
    filter.addEventListener('change', function() {
      const filterType = this.dataset.filterType;
      const selectedValue = this.value.trim();
      
      if (selectedValue) {
        activeFilters.set(filterType.toLowerCase(), selectedValue.toLowerCase());
      } else {
        activeFilters.delete(filterType.toLowerCase());
      }
      
      filterSwatches();
    });
  });

  function filterSwatches() {
    if (activeFilters.size === 0) {
      swatches.forEach(item => item.classList.remove('hidden'));
    } else {
      swatches.forEach(item => {
        const itemTags = item.dataset.tags.split(',').map(tag => tag.trim());
        const matchesAll = Array.from(activeFilters.entries()).every(([filterTypeLC, valueLC]) => {
          const fullTag = `${filterTypeLC} ${valueLC}`;
          return itemTags.includes(fullTag);
        });

        if (matchesAll) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects-main-blog"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filter = document.querySelector('.filter');
  const articles = document.querySelectorAll('.blog__article');

  filter.addEventListener('change', function() {
    const selectedCategory = this.value.trim();
    
    articles.forEach(article => {
      if (!selectedCategory || article.dataset.category === selectedCategory) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faqs"] && !Shopify.designMode) return;
  try {
    
class FaqAccordion {
  constructor() {
    this.init();
  }

  init() {
    const buttons = document.querySelectorAll('.faq-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', () => this.toggleAccordion(button));
    });
  }

  toggleAccordion(button) {
    const content = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Close all other accordions
    const allButtons = document.querySelectorAll('.faq-button');
    allButtons.forEach(btn => {
      if (btn !== button) {
        btn.setAttribute('aria-expanded', 'false');
        const otherContent = btn.nextElementSibling;
        
        // Add transition class before hiding
        otherContent.style.maxHeight = '0';
        otherContent.style.opacity = '0';
        
        // Wait for transition to complete before hiding
        setTimeout(() => {
          otherContent.hidden = true;
        }, 300);
      }
    });
    
    // Toggle current accordion
    button.setAttribute('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      // Show content before starting animation
      content.hidden = false;
      // Trigger reflow
      content.offsetHeight;
      // Start animation
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      // Start collapsing animation
      content.style.maxHeight = '0';
      content.style.opacity = '0';
      // Hide after animation
      setTimeout(() => {
        content.hidden = true;
      }, 300);
    }
  }
}

// Initialize accordion when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FaqAccordion();
});

  } catch(e) { console.error(e); }
})();
})();
